export default (function (obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/utils/has-own-property.js
// module id = 578
// module chunks = 0